import React from 'react';
import './VoiceWave.css';

const VoiceWave = ({ isActive, isAI, audioLevel = 0 }) => {
  const bars = 20;
  const color = isAI ? 'var(--primary)' : 'var(--secondary)';

  return (
    <div className={`voice-wave ${isActive ? 'active' : ''}`}>
      {Array.from({ length: bars }).map((_, i) => (
        <div
          key={i}
          className="voice-wave-bar"
          style={{
            height: isActive ? `${Math.max(4, audioLevel * 40 + Math.random() * 20)}px` : '4px',
            background: color,
            animationDelay: `${i * 0.05}s`,
            opacity: isActive ? 0.8 : 0.2,
          }}
        />
      ))}
    </div>
  );
};

export default VoiceWave;
